// Action types for the V2 reducer (self-contained — not part of the global Redux store).
export const ST_SET_LOADING = "stv2/SET_LOADING";
export const ST_SET_MONTH_GRID = "stv2/SET_MONTH_GRID";
export const ST_SET_STATUSES = "stv2/SET_STATUSES";
export const ST_SET_FLAG_METADATA = "stv2/SET_FLAG_METADATA";
export const ST_SET_FILTER = "stv2/SET_FILTER";
export const ST_PATCH_CELL_STATUS = "stv2/PATCH_CELL_STATUS";
export const ST_SET_V2_ENABLED = "stv2/SET_V2_ENABLED";
export const ST_SET_TAGGING_MODE = "stv2/SET_TAGGING_MODE";
export const ST_ADD_COACH_FLAG = "stv2/ADD_COACH_FLAG";
export const ST_ADD_COACH_FLAGS = "stv2/ADD_COACH_FLAGS";
export const ST_REMOVE_COACH_FLAG = "stv2/REMOVE_COACH_FLAG";
export const ST_REMOVE_COACH_FLAGS = "stv2/REMOVE_COACH_FLAGS";
